const accessShop = {

    SHOP_CATEGORY_LIST: { name: 'Shop Category', path: '/shop-category-list' },
    ADD_SHOP_CATEGORY: { name: 'Add Shop Category', path: '/create-shop-category' },
    UPDATE_SHOP_CATEGORY: { name: 'Update Shop Category', path: '/edit-shop-category' },
    DELETE_SHOP_CATEGORY: { name: 'Delete Shop Category', path: '/delete-shop-category' },

    SHOP_SUB_CATEGORY_LIST: { name: 'Shop Sub Category', path: '/shop-sub-category-list' },
    ADD_SHOP_SUB_CATEGORY: { name: 'Add Shop Sub Category', path: '/create-shop-sub-category' },
    UPDATE_SHOP_SUB_CATEGORY: { name: 'Update Shop Sub Category', path: '/edit-shop-sub-category' },
    DELETE_SHOP_SUB_CATEGORY: { name: 'Delete Shop Sub Category', path: '/delete-shop-sub-category' },

    SHOP_PRODUCT_LIST: { name: 'Shop Product', path: '/shop-product-list' },
    ADD_SHOP_PRODUCT: { name: 'Add Shop Product', path: '/create-shop-product' },
    UPDATE_SHOP_PRODUCT: { name: 'Update Shop Product', path: '/edit-shop-product' },
    DELETE_SHOP_PRODUCT: { name: 'Delete Shop Product', path: '/delete-shop-product' },

}

export default accessShop;
